export default "__VITE_ASSET__CQzcH52Z__"